import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * `translate` pipe (named to match the AngularJS `| translate` so ported
 * templates `{{ 'key' | translate }}` read identically to their originals) —
 * now backed by the native ngx `TranslateService.instant` (the WS2 translate
 * sweep drained the AngularJS `$translate` `$injector` bridge; the
 * AngularTranslateCompatParser keeps it byte-identical to angular-translate
 * incl. `$sanitize`). Declared in LegacyShimsModule + re-exported via
 * AccountSharedModule so every ported feature module's `| translate` resolves
 * here for free.
 */
@Pipe({
    name: 'translate',
    standalone: false
})
export class LegacyTranslatePipe implements PipeTransform {
    private readonly translate = inject(TranslateService);

  transform(key: string | null | undefined, params?: object): string {
    if (!key) return '';
    return this.translate.instant(key, params);
  }
}
